import { createMiddleware } from "@tanstack/react-start";

// Same job as the generated `attachSupabaseAuth`, but the Supabase client is
// imported lazily and only when a stored session actually exists. This app has
// no end-user auth today, so this keeps supabase-js (~150KB) out of the
// critical bundle while still attaching the bearer token if auth is added.
function hasStoredSession(): boolean {
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith("sb-") && k.endsWith("-auth-token")) return true;
    }
  } catch {
    /* storage unavailable */
  }
  return false;
}

export const attachSupabaseAuthLazy = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    if (typeof window === "undefined" || !hasStoredSession()) return next();
    const { supabase } = await import("@/integrations/supabase/client");
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({ headers: token ? { Authorization: `Bearer ${token}` } : {} });
  },
);
